import { Component, OnInit } from '@angular/core';
import { StateService } from '../../services/state.service';
import { VehicleService } from '../../services/vehicle.service';

@Component({
  selector: 'app-openmap',
  templateUrl: './openmap.component.html',
  styleUrls: ['./openmap.component.css']
})
export class OpenmapComponent implements OnInit {

  map:any = {};
  markers = [];
  infoContent = '';
  vehicles:any = [];
  openedInfoWdws = [];
  bounds:any = {};
  vehicleSubs:any;
  showPois = false;
  showZones = false;
  showControls = true;
  showMultipleOnMap = false;
  tileLayer:any;
  
  poisList:any = [];
  zonesList:any = [];
  
  zoom = 12;
  center = [
		3.129958, 
    101.67509
  ];

  constructor(private stateSvc: StateService, private vehicleSvc: VehicleService) { }

  ngOnInit(): void {
    this.map = L.map('map-open',{zoomAnimation: false,
    markerZoomAnimation: false, preferCanvas: true}).setView(this.center, this.zoom);
    this.tileLayer = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map);
    this.stateSvc.setMapInstance(this.map);
    this.vehicleSubs = this.stateSvc.vehicles
    .subscribe((result) => {
      let vhcls = result;
      this.vehicles = vhcls;
      let hadShownVehicle = false;
      this.vehicles?.forEach((vhcl) => {
        if(vhcl.shownOnMap && this.map?.mapTypeId){
          hadShownVehicle = true;
          return;
        }
      });
      if(!hadShownVehicle && !this.showPois && !this.showZones){
        // this.map.setZoom(this.zoom);
      }
    });
    this.stateSvc.showMultipleOnMap
    .subscribe((result) => {
      this.showMultipleOnMap = result;
    });
    this.vehicleSvc.processUserPois(this.map);
    this.vehicleSvc.processUserZones(this.map);
    this.stateSvc.userPois
    .subscribe((pois) => {
      this.poisList = pois;
    });
    this.stateSvc.userZones
    .subscribe((zones) => {
      this.zonesList = zones;
    });
    this.map.initialZoom = true;
    this.map.on('load', () => {
        this.stateSvc.setMapLoaded(true);
    });
    this.tileLayer.on('tileload', () => {
        this.stateSvc.setMapLoaded(false);
    });
  }

  poiToggle(){
    this.showPois = !this.showPois;
    this.drawPois();
  }
  
  zonesToggle(){
    this.showZones = !this.showZones;
    this.drawZones();
  }
  
  resetZoom(){
    let currentMapProvider = this.stateSvc.getMapType();
    if(currentMapProvider == "Google"){
      this.bounds = new google.maps.LatLngBounds();
      let hadShownVehicle = false;
      this.vehicles.forEach((vehicle) => {
        if (vehicle.marker?.getMap()) {
          this.bounds.extend(vehicle.marker.getPosition());
        }
        if(vehicle.shownOnMap){
          hadShownVehicle = true;
        }
      });
      if(this.map?.mapTypeId && this.bounds && hadShownVehicle){
        this.map.fitBounds(this.bounds);
      }else if(!hadShownVehicle){
        this.map.setZoom(this.zoom);
      }
    }else{
      this.bounds = [];
      let hadShownVehicle = false;
      this.vehicles.forEach((vehicle) => {
        if (vehicle.marker) {
          this.bounds.push([vehicle.lat, vehicle.lon]);
        }
        if(vehicle.shownOnMap){
          hadShownVehicle = true;
        }
      });
      if(this.bounds.length > 0 && hadShownVehicle){
        this.map.fitBounds(this.bounds);
      }else if(!hadShownVehicle){
        this.map.setZoom(this.zoom);
      }
    }
  }
  
  toggleShowControl(){
    this.showControls = !this.showControls; 
    this.stateSvc.setShowControl(this.showControls);
  }
  
  drawPois(){
    let currentMapProvider = this.stateSvc.getMapType();
    let zoom = this.map.getZoom();
    if(currentMapProvider == 'Google'){
      if (zoom >= 14 && this.showPois) {
        this.poisList.forEach((poi) => {
          !poi.getMap() && poi.setMap(this.map);
        });
      } else {
        this.poisList.forEach((poi) => {
          poi.getMap() && poi.setMap();
        });
      }
    }else{
      if (this.showPois) {
        this.poisList.forEach((poi) => {
          poi.addTo(this.map);
        });
      }else{
        this.poisList.forEach((poi) => {
          this.map.removeLayer(poi);
        });
      }
    }
  }
  
  drawZones(){
    let currentMapProvider = this.stateSvc.getMapType();
    let zoom = this.map.getZoom();
    if(currentMapProvider == 'Google'){
      if (this.showZones) {
        this.zonesList.forEach((zone) => {
          zone.setMap(this.map);
        });
      }else {
        this.zonesList.forEach((zone) => {
          zone.setMap(null);
        });
      }
    }else{
      if (this.showZones) {
        this.zonesList.forEach((zone) => {
          zone.addTo(this.map);
        });
      }else{
        this.zonesList.forEach((zone) => {
          this.map.removeLayer(zone);
        });
      }
    }
  }

  mapProviderToggle(){
    this.stateSvc.setMapType('Google');
    window.location.reload(true);
  }

}
